import moment from 'moment';
import { IHomeViewFilters, ITaskFilterValues } from './ControlTower.types';
import { IActivityTabFilters } from './Activity/Activity.types';
import {
  SET_HOME_VIEW_FILTERS,
  SET_MY_WORK_FILTERS,
  SET_MY_WORK_FILTERS_SEEDED,
  SET_ACTIVITY_TAB_FILTERS,
  SET_LAST_OPENED_INCIDENT_ID,
  SET_LAST_CREATED_TICKET_ID,
} from './ControlTower.constants';

export interface IControlTowerState {
  homeViewFilters: IHomeViewFilters;
  myWorkFilters: ITaskFilterValues;
  myWorkFiltersSeeded: boolean;
  activityTabFilters: IActivityTabFilters;
  lastOpenedIncidentId: string | null;
  lastCreatedTicketId: string | null;
}

const defaultState: IControlTowerState = {
  homeViewFilters: {
    createdAt: [moment().startOf('day'), moment().endOf('day')],
  },
  myWorkFilters: {},
  myWorkFiltersSeeded: false,
  activityTabFilters: {
    createdAt: [moment().startOf('day'), moment().endOf('day')],
  },
  lastOpenedIncidentId: null,
  lastCreatedTicketId: null,
};

export default function controlTowerReducer(state = defaultState, action: { type: string; data: any }) {
  switch (action.type) {
    case SET_HOME_VIEW_FILTERS:
      return { ...state, homeViewFilters: action.data };
    case SET_MY_WORK_FILTERS:
      return { ...state, myWorkFilters: action.data };
    case SET_MY_WORK_FILTERS_SEEDED:
      return { ...state, myWorkFiltersSeeded: action.data };
    case SET_ACTIVITY_TAB_FILTERS:
      return { ...state, activityTabFilters: action.data };
    case SET_LAST_OPENED_INCIDENT_ID:
      return { ...state, lastOpenedIncidentId: action.data };
    case SET_LAST_CREATED_TICKET_ID:
      return { ...state, lastCreatedTicketId: action.data };
    default:
      return state;
  }
}
